<div class="custella-login">
    
    <!-- Language -->
    <div class="language">
        <li class="custella-lang-front">
            <div class="custella-lang-menu accordion accordion-flush">
                <div class="accordion-item">
                    <div class="accordion-header" id="language">
                        <button class="accordion-button collapsed justify-content-between px-1 py-2" data-bs-toggle="collapse" data-bs-target="#choose-lang" aria-expanded="false" aria-controls="choose-lang">
                            <div class="flex-align-center">
                                <span class="fi fi-{{currentLang.flag}} me-2"></span>
                                <span class="text-12 ms-2">{{currentLang.value}}</span>

                                <!-- <span class="text-12 font-white" *ngIf="currentLang === 'Malay'">
                                    Malay
                                </span>

                                <span class="text-12 font-white" *ngIf="currentLang === 'Chinese'">
                                    Chinese
                                </span> -->
                            </div>
                            <i class="fa-regular fa-chevron-down ms-4"></i>
                        </button>

                    </div>
                    <ul class="p-0 m-0 accordion-collapse collapse"  id="choose-lang" #chooseLang>
                        <ng-container *ngFor="let lang of languageList">
                            <li class="py-1 px-0 my-0"aria-labelledby="language"  *ngIf="currentLang != lang" (click)="onChangeLanguage(lang)">
                                <a class="px-1">
                                    <span class="fi fi-{{lang.flag}} me-2"></span>
                                    <span class="text-12 ms-2">{{lang.value}}</span>
                                </a>
                            </li>
                        </ng-container>
                    </ul>
                </div>
            </div>
        </li>
    </div>


    <div class="container">
        <div class="row">
            <!-- <div class="col-sm-9 col-md-7 col-lg-4 mx-auto"> -->
            <div class="mx-auto">
              <div class="card border-0 shadow rounded-3 my-5">
                <div class="card-body py-4 px-3 px-sm-3 py-sm-4">
                    <span>
                        <img src="../../../assets/svg/FieldEx_L_T.svg" alt="FieldEx Logo">
                    </span>
                    <h3 class="card-title font-bold pt-5 pb-4">{{langData.resetPassword.sections.sec1.singular}}</h3>
                    <form  [formGroup]="forgotPasswordForm">
                        <div class="form-group">
                            <label>{{langData.resetPassword.fields.newPassword.singular}}</label>

                            <div class="pwd-valid" *ngIf="showtooltip || isPasswordHasUserName">
                                <div class="pwd-valid-body">
                                    <div class="pb-1">
                                        <span>{{langData.resetPassword.messages.passwordRequirement}}&colon;</span>
                                    </div>
                                    <div class="flex-align-center pb-1">
                                        <span class="w-12px lh-1">
                                            <i class="fa-regular fa-check text-success" *ngIf="passwordFormField?.value?.match('^(?=.*[A-Z])')"></i>
                                            <i class="fa-regular fa-xmark p-error" *ngIf="!passwordFormField?.value?.match('^(?=.*[A-Z])')"></i>
                                        </span>
                                        <span class="ms-2"[ngClass]="passwordFormField?.value?.match('^(?=.*[A-Z])') ? 'text-success':''">{{langData.resetPassword.messages.oneUppercase}}</span>
                                    </div>
                                    <div class="flex-align-center pb-1">
                                        <span class="w-12px lh-1">
                                            <i class="fa-regular fa-check text-success" *ngIf="passwordFormField?.value?.match('^(?=.*[a-z])')"></i>
                                            <i class="fa-regular fa-xmark p-error" *ngIf="!passwordFormField?.value?.match('^(?=.*[a-z])')"></i>
                                        </span>
                                        <span class="ms-2" [ngClass]="passwordFormField?.value?.match('^(?=.*[a-z])') ? 'text-success':''">{{langData.resetPassword.messages.oneLowercase}}</span>
                                    </div>
                                    <div class="flex-align-center pb-1">
                                        <span class="w-12px lh-1">
                                            <i class="fa-regular fa-check text-success" *ngIf="passwordFormField?.value?.match('(.*[0-9].*)')"></i>
                                            <i class="fa-regular fa-xmark p-error" *ngIf="!passwordFormField?.value?.match('(.*[0-9].*)')"></i>
                                        </span>
                                        <span class="ms-2" [ngClass]="passwordFormField?.value?.match('(.*[0-9].*)') ? 'text-success':''">{{langData.resetPassword.messages.oneNumeric}}</span>
                                    </div>
                                    <div class="flex-align-center pb-1">
                                        <span class="w-12px lh-1">
                                            <i class="fa-regular fa-check text-success" *ngIf="passwordFormField?.value?.match('(?=.*[!@#$%^&*])')"></i>
                                            <i class="fa-regular fa-xmark p-error" *ngIf="!passwordFormField?.value?.match('(?=.*[!@#$%^&*])')"></i>
                                        </span>
                                        <span class="ms-2" [ngClass]="passwordFormField?.value?.match('(?=.*[!@#$%^&*])') ? 'text-success':''">{{langData.resetPassword.messages.oneSymbol}}</span>
                                    </div>
                                    <div class="flex-align-center pb-1">
                                        <span class="w-12px lh-1">
                                            <i class="fa-regular fa-check text-success" *ngIf="passwordFormField?.value?.match('.{8,}')"></i>
                                            <i class="fa-regular fa-xmark p-error" *ngIf="!passwordFormField?.value?.match('.{8,}')"></i>
                                        </span>
                                        <span class="ms-2"  [ngClass]="passwordFormField?.value?.match('.{8,}') ? 'text-success':''">{{langData.resetPassword.messages.minimumChars}}</span>
                                    </div>
                                   
                                </div>
                             </div>


                            <span class="p-input-icon-left p-input-icon-right">
                                <i class="fa-regular fa-lock-keyhole pe-none"></i>
                                <input pInputText [(ngModel)]="forgotPassword.password" id="input_PwdActivateNewPwdField" [type]="fieldTextType ? 'text' : 'password'" formControlName="password" name="password" (input)="getPassowrdLength($event)">
                                <i class="pi" [ngClass]="fieldTextType ? 'pi-eye': 'pi-eye-slash'" id="btn_PwdActivateNewPwd"(click)="toggleFieldTextType()"></i>
                            </span>
                            <div *ngIf="forgotPasswordForm.controls['password'].touched && forgotPasswordForm.controls['password'].invalid">
                                <span class="p-error text-10" *ngIf="forgotPasswordForm.controls['password'].errors?.required" id="label_PwdNewPwdReqField">{{langData.general.validationFE.requiredField}}</span>
                                <!-- <span class="p-error text-10" *ngIf="forgotPasswordForm.controls['password'].errors?.pattern || isPasswordValid" id="label_PwdNewPwdMustBe">Please ensure your password meets all the specified criteria</span>-->
                            </div> 
                            <span id="label_PwdActivateRetypePwdReqField" class="p-error text-10">{{errorMsg}}</span>
                           
                        </div>
                        <div class="form-group">
                            <label>{{langData.resetPassword.fields.confirmPassword.singular}}</label>
                            <span class="p-input-icon-left p-input-icon-right">
                                <i class="fa-regular fa-lock-keyhole pe-none"></i>
                                <input pInputText [(ngModel)]="forgotPassword.cPassword" id="input_PwdActivateRetypePwdField" [type]="fieldTextType2 ? 'text' : 'password'" (input)="getCPassowrdLength($event)" formControlName="confirmPassword" name="cPassword">
                                <i class="pi" [ngClass]=" fieldTextType2 ? 'pi-eye': 'pi-eye-slash'" id="btn_PwdActivateRetypePwd"(click)="toggleFieldTextType2()"></i>
                            </span>
                            
                            <div *ngIf="forgotPasswordForm.controls['confirmPassword'].touched && forgotPasswordForm.controls['confirmPassword'].invalid">
                                <span class="p-error text-10" *ngIf="forgotPasswordForm.controls['confirmPassword'].errors?.required" id="label_PwdRetypePwdReqField" >{{langData.general.validationFE.requiredField}}</span>
                            </div>
                            <div *ngIf="!isPasswordMatching && (forgotPassword.cPassword && forgotPassword.cPassword.length > 0)">
                                <span class="p-error text-10" id="label_PwdActivateRetypePwdReqField">{{langData.resetPassword.validationFE.passwordsDoNotMatch}}</span>
                                <!-- <span class="p-error text-10" id="label_PwdActivateRetypePwdMustBe" *ngIf="accountForm.controls['cPassword'].errors?.pattern" >{{'password_must_be'}}</span> -->
                            </div>
                        </div>

                        <div class="mt-4">
                            <button type="button" (click)="submitResetPassword()" class="custella-btn-long" id="btn_ResetPwdSubmit">
                                <span class="text-12">{{langData.createProfile.buttons.create.singular}}</span>
                            </button>
                        </div>
                    </form>
                </div>
              </div>
            </div>
        </div>
    </div>
</div>

